import React, { useState } from "react";

import { FormattedMessage } from "react-intl";

import StarRating from "./StarRating";
import ValidationSection from "./ValidationSection";

import { useRateConversationMutation } from "../../../utils/queries/conversations";
import { useWebmessenger } from "../../../utils/webmessenger";

const starsTable = [1, 0.8, 0.6, 0.4, 0.2];

function VisitorSatisfaction() {
    const { conversation } = useWebmessenger();
    const [selectedStars, setSelectedStars] = useState(null);
    const [disableStars, setDisableStars] = useState(false);
    const [showValidation, setShowValidation] = useState(false);

    const { mutate: rateConversation } = useRateConversationMutation(
        conversation?._id,
        {
            onSuccess: () => {
                setTimeout(() => {
                    setDisableStars(false);
                    setShowValidation(true);
                }, 600);
            },
            enabled: !!conversation?._id && !disableStars,
        }
    );

    const handleStarClick = (rating) => {
        if (!disableStars) {
            setSelectedStars(rating);
            setDisableStars(true);

            rateConversation({ satisfactionRating: rating });
        }
    };

    return (
        <div className="ek-chat__satisfaction">
            {!showValidation && (
                <span className="ek-chat__satisfaction--title">
                    <FormattedMessage
                        id="WEBMESSENGER.CONVERSATION.VISITOR_SATISFACTION_TITLE"
                        defaultMessage="Votre expérience avec le tchat en ligne"
                    />
                </span>
            )}
            <div className="ek-chat__satisfaction--stars">
                {!showValidation &&
                    starsTable.map((rating) => (
                        <StarRating
                            key={rating}
                            rating={rating}
                            selectedStars={selectedStars}
                            disableStars={disableStars}
                            handleStarClick={handleStarClick}
                        />
                    ))}
            </div>
            {showValidation && (
                <ValidationSection selectedStars={selectedStars} />
            )}
        </div>
    );
}

export default VisitorSatisfaction;
